class ecomGiftCardFunction {
    gift_form = null;
    opt_countdown = null;
    DEFAULT_OTP_SECONDS = 120;
    otp_seconds= this.DEFAULT_OTP_SECONDS;
    
    constructor() {
        this.createPhoneInputs();
        
        document.addEventListener("click", e=>{
            if(e.target.closest(".cart-btn-ecom-gift")) {
                e.preventDefault();
                this.gift_form = e.target.closest(`form[action="/cart/add"]`);
                this.gift_form_validate(e);
                return;
            }

            if(e.target.closest(".send-otp-gift-cart")) {
                e.preventDefault();
                this.sendOtp(e);
                return;
            }

            if(e.target.closest(".verify-otp-gift")) {
                e.preventDefault();
                this.validateOtp();
                return
            }

            if(e.target.closest(".gift-otp-close")) {
                e.preventDefault();
                this.gift_form.querySelector(".cart-btn-ecom-gift").disabled = false;
                this.gift_form.querySelector(`.otp-number-wrapper`).hidden = false;
                this.gift_form.querySelector(`.otp-verify-wrapper`).hidden = true;
                this.otp_seconds = this.DEFAULT_OTP_SECONDS
                clearInterval(this.opt_countdown);
                this.openPopup(false);
            }
        });
    }

    createPhoneInputs() {
        const phoneInputs = document.querySelectorAll(`.ecom-addtocart-gift [type="tel"]`);
        phoneInputs.forEach(item=>{
            window.intlTelInput(item, {
                 initialCountry: "lk",
                 preferredCountries: ["lk"],
                 utilsScript:
                   "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/utils.js",
             });
        })
    }

    isValidEmail(email) {
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailPattern.test(email);
    }
    
    gift_form_validate(e) {
      const receiverEmailElem = this.gift_form.querySelector(`#gift-receiver-email`);
      const receiverPhoneElem = this.gift_form.querySelector(`#gift-receiver-phone`);
      const cxEmailElem = this.gift_form.querySelector(`[name="properties[_cx-email]"]`);
      const hiddenRecipientName = this.gift_form.querySelector(`[name="properties[_recipient_name]"]`);
      const recipientName = this.gift_form.querySelector(`[name="properties[Recipient name]"]`);
      
      const iti = window.intlTelInputGlobals.getInstance(receiverPhoneElem); // Get instance directly
      const phoneNumber = iti.getNumber();
      let isValidPhone = iti.isValidNumber();
    
      let enteredNumber = iti.getNumber();
      enteredNumber = enteredNumber.replaceAll("+","");
      
      //if number contains 074 then return true, because dialog have 074 
      console.log(enteredNumber.length);
      console.log(enteredNumber);
      console.log(enteredNumber.startsWith("+9474"));
      if(enteredNumber.length == 11 && enteredNumber.startsWith("9474")) {
        console.log("Set valid number ");
        isValidPhone = true;
      }

      const isEmailValid = this.isValidEmail(receiverEmailElem.value);
      if(isEmailValid == false) {
          receiverEmailElem.classList.add("error");
      }else {
          receiverEmailElem.classList.remove("error");
      }

      console.log({isValidPhone, phoneNumber})
      if(isValidPhone == false) {
        receiverPhoneElem.classList.add("error");  
      }else {
          receiverPhoneElem.classList.remove("error");
      }

      if( !isEmailValid) {
          return;
      }
      if( !isValidPhone) {
          return;
      }

      if(e) {
          e.target.closest(".cart-btn-ecom-gift").disabled = true;
      }
      
      cxEmailElem.value = receiverEmailElem.value;
      receiverPhoneElem.value = enteredNumber;
      hiddenRecipientName.value = recipientName.value
      //open popup
      this.openPopup();
    }

    openPopup(open= true) {
        if(open) {
            this.gift_form.querySelector(`.gift-otp-popup`).hidden =false;
        }else {
            this.gift_form.querySelector(`.gift-otp-popup`).hidden =true;
        }
    }

    proceedToCheckout() {
        this.gift_form.addEventListener("submit", e=>{
          e.preventDefault();
        });
        this.gift_form.querySelectorAll(`.shopify-payment-button *`).forEach(elem=>elem.disabled = false)
        this.gift_form.querySelector(`shopify-accelerated-checkout`).disabled = false;
        this.gift_form.querySelector(`.ecom-addtocart-gift .shopify-payment-button__button`).disabled = false;
        this.gift_form.querySelector(`.ecom-addtocart-gift .shopify-payment-button__button`).dispatchEvent(new Event("click"));
    }

    async validateOtp() {
        const otpTextElem = this.gift_form.querySelector(".otp-input");
        const errorOtp =  this.gift_form.querySelector(".invalid-otp");
        
        try {
          const otp_verified_status = await ecomVerifyOtp(otpTextElem.value);
          console.log({otp_verified_status});
    
          if(otp_verified_status.otp == "error") {
            errorOtp.hidden = false;
            return ;
          }

            errorOtp.hidden = true;
            this.proceedToCheckout();
        }catch(e) {
         
          return ;
        }
    }
    
    sendOtp(e) {
        
            // BECAUSE OF THE SMS GATEWAY FAILURE WE DIRECTLY CHECKOUT GIFT VOUCHER | REMOVE WHEN WORKING | START
            return this.proceedToCheckout();
            // BECAUSE OF THE SMS GATEWAY FAILURE WE DIRECTLY CHECKOUT GIFT VOUCHER | REMOVE WHEN WORKING | END
        

        const senderPhoneElem = this.gift_form.querySelector(`.sender-phone`);
        
        const iti = window.intlTelInputGlobals.getInstance(senderPhoneElem); // Get instance directly
        const phoneNumber = iti.getNumber();
        let isValidPhone = iti.isValidNumber();
      
        let enteredNumber = iti.getNumber();
        enteredNumber = enteredNumber.replaceAll("+","");
        
        //if number contains 074 then return true, because dialog have 074 
        console.log(enteredNumber.length);
        console.log(enteredNumber);
        console.log(enteredNumber.startsWith("+9474"));
        if(enteredNumber.length == 11 && enteredNumber.startsWith("9474")) {
          console.log("Set valid number ");
          isValidPhone = true
        }

        if(isValidPhone == false) {
            senderPhoneElem.classList.add("error");
            return;
        }else {
            senderPhoneElem.classList.remove("error");
        }

        this.request_otp(phoneNumber);

        this.gift_form.querySelector(`.otp-number-wrapper`).hidden = true;
        this.gift_form.querySelector(`.otp-verify-wrapper`).hidden = false;
        
        this.startCountdown();
    }

    startCountdown() {
        const otpCountdownElem = this.gift_form.querySelector(".otp-countdown");
        
        this.opt_countdown = setInterval(()=>{
            if(this.otp_seconds > 0) {
                this.otp_seconds -=1;
                otpCountdownElem.textContent = this.otp_seconds + "s";
            }

            if(this.otp_seconds <= 0) {
                //show resend 
                console.log("show resend")
                clearInterval(this.opt_countdown);
            }
        }, 999)
    }

    async request_otp(phone) {
        try {
          const result = await ecomSendOtp(phone);
          console.log(result);
          return true;
        } catch(e) {
          console.log(e);
          return false;
        } 
      }
}
window.ecomGiftCard = new ecomGiftCardFunction();